module.exports = __webpack_public_path__ + "static/media/italic.79574941.svg";